import { h, render } from 'preact';

import EmbedContainer from './components/embed-container';

render(
  <EmbedContainer></EmbedContainer>,
  document.getElementById('app')
);

require('preact/devtools');



// WEBPACK FOOTER //
// ./embed.js